import { useCallback, useMemo } from 'react';
import OrderFullscreenModal from './common/OrderFullscreenModal';
import { useOrderContext } from '../../../../providers/OrderProvider';
import Message from '../../../../components/Message';
import OrderFullscreenModalBody from './common/OrderFullscreenModalBody';
import OrderModalFooter from './common/OrderModalFooter';
import OrderModalHeader from './common/OrderModalHeader';
import OrderDetailModalBody from './common/OrderDetailModalBody';

const ProcessingOrderModal = ({ setIsOpenPendingModal, isOpenPendingModal }) => {
	const { order, isLoading, isError, orderDetailsError, currentOrderOId } = useOrderContext();
	const { orderId, customerInfo, approvalStatus, isCompleted } = order ?? {};
	const hasOrderForCurrent = Boolean(order?._id && currentOrderOId && String(order._id) === String(currentOrderOId));
	// 已有当前单缓存时，刷新失败不整页当成「无权」（待核验常见误报）
	const showLoadError = isError && !hasOrderForCurrent;
	const loadErrorMessage =
		orderDetailsError?.data?.message || orderDetailsError?.error || '无法加载订单详情，您可能无权查看该订单。';

	const handleClose = useCallback(() => {
		setIsOpenPendingModal(false);
	}, [setIsOpenPendingModal]);

	const paymentStatusBadge = useMemo(() => order?.uiHints?.modalStatusBadges?.default ?? null, [order]);

	return (
		<OrderFullscreenModal show={isOpenPendingModal} onHide={handleClose}>
			<OrderModalHeader
				orderId={orderId}
				customerInfo={customerInfo}
				isLoading={isLoading}
				isCompleted={isCompleted}
				approvalStatus={approvalStatus}
				badges={paymentStatusBadge ? [paymentStatusBadge] : []}
			/>
			<OrderFullscreenModalBody isLoading={isLoading}>
				{showLoadError ? (
					<Message variant='danger' className='my-4'>
						{loadErrorMessage}
					</Message>
				) : (
					<OrderDetailModalBody notesType='pay' />
				)}
			</OrderFullscreenModalBody>
			<OrderModalFooter />
		</OrderFullscreenModal>
	);
};

export default ProcessingOrderModal;
